import { IonIcon, IonText } from "@ionic/react";
import { ComponentProps } from "react";
import { useIntl } from "react-intl";

import styles from "@components/typography/Typography.module.css";
import { Colors } from "@utils/colorUtils";
import { IconList, IconName } from "@utils/iconUtils";

type Props = Pick<ComponentProps<typeof IonIcon>, "aria-describedby" | "onBlur" | "onFocus" | "role" | "tabIndex"> & {
  ariaLabelKey: string;
  color?: Colors;
  disabled?: boolean;
  icon: IconName;
  size?: "small" | "medium" | "large";
};

const ActionIcon = ({ ariaLabelKey, color = "primary", disabled, icon, size = "medium", ...iconProps }: Props) => {
  const intl = useIntl();
  const wrapperStyles = [styles.actionIcon];

  if (disabled) {
    wrapperStyles.push(styles.actionIconDisabled);
  }

  if (icon === "spinner") {
    wrapperStyles.push(styles.spin);
  }

  if (size === "small") {
    wrapperStyles.push(styles.actionIconSmall);
  } else if (size === "medium") {
    wrapperStyles.push(styles.actionItemMedium);
  } else if (size === "large") {
    wrapperStyles.push(styles.actionIconLarge);
  }

  return (
    <IonText className={styles.iconWrapper} color={color}>
      <IonIcon
        aria-label={intl.formatMessage({ id: ariaLabelKey })}
        className={wrapperStyles.join(" ")}
        src={IconList[icon]}
        {...iconProps}
      />
    </IonText>
  );
};

export default ActionIcon;
